import { defineHub } from "../classes/HubDefinition";
export default defineHub({
    // #region Run
    name: 'data',
    // #endregion
    // #region Core
    async execute(command, args) {
        if (command.address === 'setvalue') {
            return await this.setProperty(command, args);
        }
        else if (command.address === 'getvalue') {
            return await this.getProperty(command, args);
        }
        else if (command.address === 'getobject') {
            return await this.getObject(command, args);
        }
        else {
            appHost.notification.showToast("Invalid command '" + command.address + "' in handler '" + this.name + "'.", "warning");
            return this.Cancel();
        }
    },
    // #endregion
    // #region Methods
    methods: {
        async getProperty(command, args) {
            // #region Data
            let tData = args.data;
            let tResult = {};
            // #endregion
            // #region Move
            if (command.data.address) {
                command.data.address.forEach((k) => {
                    if (!tData) {
                        return;
                    }
                    var tID = tData.__g_key;
                    {
                        if (tID === k.key) {
                            return;
                        }
                        else if (tData[k.name]) {
                            tData = tData[k.name].find(e => e.__g_key === k.key);
                        }
                    }
                });
            }
            // #endregion
            // #region Log
            utils.logDebug("getProperty", tData);
            // #endregion
            if (tData && command.data && command.data.properties) {
                command.data.properties.forEach((f) => {
                    utils.setObjectValue(tResult, f.name, utils.getObjectValue(tData, f.name));
                });
            }
            return this.Ok(tResult);
        },
        async getObject(command, args) {
            return this.Ok(args.data);
        },
        async setProperty(command, args) {
            // #region Data
            let tData = args.data;
            {
                if (!command?.data?.properties) {
                    return this.Ok();
                }
                if (!tData) {
                    return this.Ok();
                }
            }
            // #endregion
            // #region Move
            if (command.data.address) {
                command.data.address.forEach((k) => {
                    if (!tData) {
                        return;
                    }
                    var tID = tData.__g_key;
                    {
                        if (tID === k.key) {
                            return;
                        }
                        else if (tData[k.name]) {
                            tData = tData[k.name].find(e => e.__g_key === k.key);
                        }
                    }
                });
            }
            // #endregion
            // #region Core
            let tProps = command.data.properties;
            // #endregion
            // #region Set
            this.diableEvents(tData, () => {
                for (let tItem of tProps) {
                    if (utils.isArray(tItem.value)) {
                        //TODO
                    }
                    else if (utils.isObject(tItem.value)) {
                        //TODO
                    }
                    else {
                        tData[tItem.name] = tItem.value;
                    }
                }
            });
            // #endregion
            return this.Ok();
        },
        diableEvents(object, callback) {
            try {
                //Lock
                if (object.__g_proxy) {
                    object.__g_proxy.locks = (object.__g_proxy?.locks ?? 0) + 1;
                }
                //Run
                callback();
            }
            finally {
                if (object.__g_proxy) {
                    object.__g_proxy.locks = object.__g_proxy.locks - 1;
                }
            }
        }
    }
    // #endregion
});
